export enum FiltroParcelamentoCupom {
  Todos = 0,
  Por_Nome = 1,
  Por_Cpf_Cnpj = 2,
  Por_Conta = 3,
  Por_PA = 4,
  Por_Vencimento = 5
}
